<button class="hover-button" (click)="exportCSV()">Extract data</button>